
import { Box, Typography, useMediaQuery } from "@mui/material"
import { PageRowSection, ReferanceCard } from "../../components"
import { useTranslation } from "react-i18next"
import { theme } from "../../../../utils"
import { collaboratingCollegueFilePath } from "../../../../assets/data"
import PartnershipEssential from "./PartnershipEssential"
import TransMsg from './transMessage'
import { desktopEdHubReferences, mobileEdHubReferences } from "../../../../assets/data/educationHub/referancesData"
import {DownloadButton, DownloadButtonType} from "../../../../components";
import FilePdfIcon from "../../../../assets/images/svgs/file-pdf.svg";


const styles = {
    identification: {
        ...theme.typography.poppinsBodyBold,
        color: theme.palette.primary.main,
        fontSize: "20px",
        paddingRight: "10px",
        lineHeight: "26px"
    },
    downloadText: {
        ...theme.typography.montseratBodyRegular,
        fontSize: "16px",
        color: theme.palette.primary.main,
        textTransform: "capitalize"
    },
    rightElementView: {
        display: "flex",
        flexDirection: "column"
    }
}

const CollaboratingColleagues = () => {
    const { t } = useTranslation()
    const isMobileX = useMediaQuery(theme.breakpoints.down(700))

    return (
        <>
            <PartnershipEssential />
            <PageRowSection
                title={t(TransMsg.GET_STARTED)}
                description={t(TransMsg.GET_STARTED_DESCRIPTION)}
                containerBoxSx={{ gap: "80px" }}
                sectionWrapperSx={{ pt: "77px", pb: "78px" }}
                rowImageSx={{ maxWidth: "529px", height: "194px" }}
                rightElement={
                    <Box sx={isMobileX ? { ...styles.rightElementView } : null}>
                        <Typography sx={styles.identification}>
                            {t(TransMsg.PATIENT_IDENTIFICATION)}
                        </Typography>
                        <Box sx={{display: "flex", mt: "8px", ml: isMobileX ? "-15px" : "none"  }}>
                            <DownloadButton fileUrl={collaboratingCollegueFilePath} buttonIcon={FilePdfIcon} buttonText="Open PDF" buttonType={DownloadButtonType.Pdf} />
                        </Box>
                    </Box>
                }
            />
            <ReferanceCard
                referanceData={isMobileX ? mobileEdHubReferences : desktopEdHubReferences}
                wrapperSx={{ py: "27px" }}
            />
        </>
    )
}

export default CollaboratingColleagues